export function formatNumber(n) {
    return String(Math.floor(n * 100) / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

export function stringToDate (dateStr,separator){
    if(!separator){
        separator="-";
    }
    let dateArr = dateStr.split(separator);
    let year = parseInt(dateArr[0]);
    let month;
    //处理月份为04这样的情况
    if(dateArr[1].indexOf("0") == 0){
        month = parseInt(dateArr[1].substring(1));
    }else{
        month = parseInt(dateArr[1]);
    }
    let day = parseInt(dateArr[2]);
    let date = new Date(year,month -1,day);
    return date;
}

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

/*
取当前日期前后多少天的日期
 */
export function dayOfDateNum(num){

    let date1 = new Date();
        //time1=date1.getFullYear()+"-"+(date1.getMonth()+1)+"-"+date1.getDate();//time1表示当前时间
    let date2 = new Date(date1);
    date2.setDate(date1.getDate()+num);
    return date2;
    //let time2 = date2.getFullYear()+"-"+(date2.getMonth()+1)+"-"+date2.getDate();
}

export function getMinDate(){
    let fullYear = new Date().getFullYear();
    return new Date(fullYear-2, 0, 1);
}

export function getMaxDate(){
    let fullYear = new Date().getFullYear();
    return new Date(fullYear+2, 11, 31);
}

export function getYear(){
    let minYear = getMinDate().getFullYear();
    let maxYear = getMaxDate().getFullYear();
    let years = [];
    for(let i = minYear ; i <= maxYear ; i++){
        years.push(i);
    }

    return years.reverse();
}
